import { defineComponent as _defineComponent } from 'vue'
import CardContainer from '@/components/card-container.vue';
import CardContentLoader from '@/components/card-content-loader.vue';
import CardTitle from '@/components/card-title.vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { i18n } from '@/i18n';
import { useECashCouponStore } from '@/store/e-cash-coupon-module';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { formatCoupon } from '@/views/home/e-cash-coupon/business';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';
import { CustomException } from '@tencent/ppd-base-libs';
import { ExecActState, execChainUseract, execUseract } from '@tencent/wphk-act-base-cgi';
import { BasicCoupon } from '@tencent/wphk-act-base-components';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { computed, onMounted, ref, toRefs } from 'vue';
import { showActExecDialog } from './business/exec-error-dialog';
import { useMerchantInfo } from '../../../store/merchant-info-module';

// 1. 把普通券、连锁券的urlParam置空（或去掉）

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const eCashCouponStore = useECashCouponStore();
const isShow = ref(true);
const isReady = ref(false);
const { merchantId } = toRefs(useMerchantInfo());
// 如果url上不带电子现金券模块的参数(eCashCp)，则不展示该模块
const isShowECashCp = computed(() => {
  if (getUrlParamByKey(UrlParamKey.eCashCp) === '1') {
    return true;
  }

  // TODO 仅限本次活动特殊逻辑使用，后续需要删除
  // https://tapd.woa.com/10145891/prong/stories/view/1010145891883953957
  const ECASH_ACT_20230601 = {
    'CM-1681201682952': 1,
    'CM-1681201886400': 1,
    'CM-1681202049537': 1,
  };
  if (ECASH_ACT_20230601[merchantId.value]) {
    return true;
  }

  return false;
});
const { simpleCouponList, chainCouponList } = toRefs(eCashCouponStore);
const { getBiExt } = useGlobalBi();
const formatSimpleCouponList = computed(() => formatCoupon(simpleCouponList.value));
const formatChainCouponList = computed(() => formatCoupon(chainCouponList.value));

async function getCoupon(item, type) {
  biClick('eCashCouponCom.getCoupon_click', { fcouponName: item.couponItem.couponName });
  showLoading();
  const exec = type === 'chain' ? execChainUseract : execUseract;
  const [err, res] = await to(exec({
    actListid: item.couponItem.actListid,
    prizeNo: item.couponItem.couponId,
  }));
  hideLoading();
  if (err) {
    showBusinessError(err);
    throw new CustomException(err, 'execCouponFail', `领取${type}失败`);
  }
  if (res?.execState === ExecActState.success) {
    type === 'chain' ? eCashCouponStore.getChainCouponList() : eCashCouponStore.getSimpleCouponList();
    biClick('eCashCouponCom.getCoupon_success', { fcouponName: item.couponItem.couponName });
  } else {
    showActExecDialog(res?.execState);
  }
}

onMounted(async () => {
  if (!isShowECashCp) {
    return;
  }
  await to(eCashCouponStore.init());
  if (simpleCouponList.value.length === 0 && chainCouponList.value.length === 0) {
    isShow.value = false;
    return;
  }
  isReady.value = true;
  biBrow('eCashCouponCom.index_brow', getBiExt());
});

return { __sfc: true,eCashCouponStore, isShow, isReady, merchantId, isShowECashCp, simpleCouponList, chainCouponList, getBiExt, formatSimpleCouponList, formatChainCouponList, getCoupon, CardContainer, CardContentLoader, CardTitle, i18n, BasicCoupon, BaseComponent }
}

})